import { Dispatch, SetStateAction } from 'react';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS, IconButton } from 'ui/button';
import { ChevronLeft16, ChevronRightNew16 } from 'ui/icons';
import { getMonthsAgo, getMonthsTo, parseDate } from 'utils/datetime';
import { addWeeks, subWeeks } from 'date-fns';
import { CalendarViewType } from 'modules/campaignsCalendar/constants';

const Navigation = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const CalendarNavigation = ({
  setCurrentDate,
  currentDate,
  viewType,
}: { currentDate: Date; setCurrentDate: Dispatch<SetStateAction<Date>>; viewType: string }) => {
  const handlePrevious = () => {
    if (viewType === CalendarViewType.Week) {
      setCurrentDate(subWeeks(currentDate, 1));
      return;
    }
    setCurrentDate(getMonthsAgo(currentDate, 1));
  };

  const handleNext = () => {
    if (viewType === CalendarViewType.Week) {
      setCurrentDate(addWeeks(currentDate, 1));
      return;
    }
    setCurrentDate(getMonthsTo(currentDate, 1));
  };

  const handleToday = () => {
    setCurrentDate(parseDate());
  };

  return (
    <Navigation data-test="calendar-navigation">
      <IconButton
        data-test="prev-button"
        variant={BUTTON_VARIANTS.GHOST}
        size={BUTTON_SIZES.SMALL}
        onClick={handlePrevious}
      >
        <ChevronLeft16 />
      </IconButton>
      <IconButton
        data-test="next-button"
        variant={BUTTON_VARIANTS.GHOST}
        size={BUTTON_SIZES.SMALL}
        onClick={handleNext}
      >
        <ChevronRightNew16 />
      </IconButton>
      <Button variant={BUTTON_VARIANTS.SECONDARY} size={BUTTON_SIZES.SMALL} onClick={handleToday}>
        Today
      </Button>
    </Navigation>
  );
};
